import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { fetchDocService } from '../services/fetch-doc.service'
import type { Manual } from '../types/release.type'

export function useDocs() {
  const [doc, setDoc] = useState<Manual>(undefined)
  const [isLoading, setIsLoading] = useState(false)
  const { slug } = useParams()

  const handleFetchDocs = async () => {
    setIsLoading(true)
    try {
      const { manual } = await fetchDocService({
        slug,
      })

      setDoc(manual)
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    handleFetchDocs()
  }, [])

  return {
    handleFetchDocs,
    doc,
    isLoading,
  }
}
